export const ultimasNoticias = [
    
    
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_101.png",
        "url" : "",
        "titulo" : 'Feria Internacional del Libro Infantil y Juvenil Hidalgo 2026',
        "fecha" : "31-07-2026"
    }, 
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_100.png",
        "url" : "https://www.facebook.com/share/p/197fwTDinC/",
        "titulo" : '2a Sesión Ordinaria del Sistema Estatal para la Integración Social de Personas con Discapacidad',
        "fecha" : "14/07/2026"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_103.png",
        "url" : "https://s-medioambiente.hidalgo.gob.mx/pdf/HIDALGO%20JUEGA%20LIMPIO.pdf",
        "titulo" : '"Hidalgo Juega Limpio" Acopio de Prendas de Mezclilla y Algodón',
        "fecha" : "06-07-2026"
    }, 
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_102.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
        "titulo" : 'Concurso Nacional "Transparencia en Corto 2026"',
        "fecha" : "02-06-2026"
    }, 
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_127.png",
        "url" : "https://www.facebook.com/share/p/1GgfZuJL9z/",
        "titulo" : 'Revisión y analisis de terrenos para la reubicación de viviendas',
        "fecha" : "01/04/2026"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_128.png",
        "url" : "https://www.facebook.com/share/p/16qxhJRwZ9/",
        "titulo" : 'Entrega de reconocimientos a personas artesanas',
        "fecha" : "20/03/2026"
    },
    
    
    
]